module.exports = __webpack_public_path__ + "img/live02.0f78c946.png";